import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useEffect } from 'react';
import { useTableColumns } from './hooks/useTableColumns';

import "assets/scss/billingPortal/modules/reporting/trialCOM.scss";
import { convertArrayToDropdownArrayFormat, getTotalCountFromHeader, isArrayNotEmpty, isObjectEmpty } from 'functions';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { MultiFilters } from 'components/filters/MultiFilters';
import { Toaster } from "components/notification/Toaster";
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';

export default function TrialCOM() {
    const {
        getAllComList_requesting, allComList
    } = useCustomSelector("accountControl");
    const {
        getTrialCOMReport_requesting, trialCOMList, trialCOMListHeaders,
    } = useCustomSelector("reporting");

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const {
        getTrialCOMReport
    } = useReporting();

    const columns = useTableColumns();

    const { getAllComList } = useAccountControlActions();
    useEffect(() => {
        getAllComList();
    }, []);

    return (
        <DashboardLayout
            headerTitle={"Trial COM"}

            bodyClassName={"trial-com-report"}
            body={(
                <GeneralTable
                    className={"trial-com-report__table"}
                    columns={columns}
                    data={userPermissions?.Internal_TrialComReport_View? trialCOMList: []}

                    getTableData={getTrialCOMReport}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section d-flex"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "COM ID", 
                                            propertyName: "comId",
                                            placeholder: "COM ID",
                                            options: (isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                let comId = obj?.ComId? obj.ComId:"";
                                                let comName = obj?.ComName? obj?.ComName:"";

                                                return {
                                                    label: comId + " - " + comName,
                                                    value: comId
                                                };
                                            }):"",
                                            inputType: "dropdown",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "COM ID", 
                                                propertyName: "comId",
                                                placeholder: "COM ID",
                                                options: (isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                    let comId = obj?.ComId? obj.ComId:"";
                                                    let comName = obj?.ComName? obj?.ComName:"";

                                                    return {
                                                        label: comId + " - " + comName,
                                                        value: comId
                                                    };
                                                }):"",
                                                inputType: "dropdown",
                                            },
                                            {
                                                label: "Company Name", 
                                                propertyName: "comName",
                                                placeholder: "Company Name",
                                                options: (isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                                    let comId = obj?.ComId? obj.ComId:"";
                                                    let comName = obj?.ComName? obj?.ComName:"";

                                                    return {
                                                        label: comName + " - " + comId,
                                                        value: comName
                                                    };
                                                }):"",
                                                inputType: "dropdown",
                                            },
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            let newFilters = isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters};
                                            setFilterOptions(newFilters);
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getTrialCOMReport_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(trialCOMListHeaders)}

                    isColumnResizeable isAllColumnWidthEqual
                    isTableOddRowsDarken
                />
            )}
        />
    );
}